import React from "react";

import { AdminSection, Button, Col, Form, Icon, Input, InputNumber, Option, Row, Select, Typography } from "components";

export const MethodTasksTab = ({
  addTask,
  deleteTask,
  tasks,
  taskIcons,
  updateTask,
  updateTaskDescription,
  updateTaskIcon,
  updateTaskMaxDate,
  updateTaskMinDate,
  updateTaskQuestion,
  updateTaskQuestionDescription,
  updateTaskQuestionOptions,
  updateTaskQuestionRequired,
}) => (
  <>
    <AdminSection
      headline="Create verification tasks"
      description={
        <>
          For users to verify their usage of a method, one or more tasks are required. The first task is always created when the method is added, and subsequent
          tasks follow the times <b>from the previous task</b>.
        </>
      }
    />
    {tasks.map((item, i) => (
      <div key={i}>
        {tasks[i] && (
          <div className="margin-bottom-200">
            <Row>
              <Col sm={12} md={12}>
                <Typography variant="paragraph-m">
                  <b>Task {tasks[i].count}</b>
                </Typography>
              </Col>
              <Col sm={12} md={12} className="right">
                {tasks[i].count > 1 && <Icon iconName="tabler/trash" className="icon-btn" onClick={() => deleteTask(i)} />}
              </Col>
            </Row>
            <Row>
              <Col>
                <Input name={`task-${i}`} label="Task" rules={[{ required: true }]} initialValue={tasks[i].title} onBlur={(v) => updateTask(i, v)} />
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  name={`description-${i}`}
                  label="Task description"
                  rules={[{ required: true }]}
                  initialValue={tasks[i].description}
                  onBlur={(v) => updateTaskDescription(i, v)}
                />
              </Col>
            </Row>
            {tasks[i].count > 1 && (
              <Row>
                <Col sm={12} md={12}>
                  <InputNumber
                    name={`minDate-${i}`}
                    label={`Weeks since task ${tasks[i].count - 1}`}
                    rules={[{ required: true, type: "number" }]}
                    className="no-suffix"
                    initialValue={tasks[i].minDate ? parseFloat(tasks[i].minDate) : undefined}
                    onBlur={(v) => updateTaskMinDate(i, v)}
                    min={0}
                    max={52}
                    step={1}
                  />
                </Col>
                <Col sm={12} md={12}>
                  <InputNumber
                    name={`maxDate-${i}`}
                    rules={[{ required: true, type: "number" }]}
                    label="to"
                    className="no-suffix"
                    initialValue={tasks[i].maxDate ? parseFloat(tasks[i].maxDate) : undefined}
                    onBlur={(v) => updateTaskMaxDate(i, v)}
                    min={tasks[i].minDate}
                    max={52}
                    step={1}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm={24} md={16}>
                <Input
                  name={`taskQuestion-${i}`}
                  label={"Question"}
                  rules={[{ required: false }]}
                  initialValue={tasks[i].question}
                  onBlur={(v) => updateTaskQuestion(i, v)}
                />
              </Col>
              <Col sm={24} md={8}>
                <Select
                  name={`taskQuestionRequired-${i}`}
                  label="Select option"
                  rules={[{ required: !!tasks[i].question }]}
                  initialValue={tasks[i].questionRequired}
                  style={{ width: "100%" }}
                  onChange={(v) => updateTaskQuestionRequired(i, v)}
                >
                  <Option value={true}>Required</Option>
                  <Option value={false}>Optional</Option>
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                  name={`taskQuestionOptions-${i}`}
                  label="Enter options"
                  rules={[{ required: !!tasks[i].question }]}
                  initialValue={tasks[i].questionValues}
                  mode="tags"
                  style={{ width: "100%" }}
                  onChange={(v) => updateTaskQuestionOptions(i, v)}
                >
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Input
                  name={`taskQuestionDescription-${i}`}
                  label={"Question description"}
                  rules={[{ required: false }]}
                  initialValue={tasks[i].questionDescription}
                  onBlur={(v) => updateTaskQuestionDescription(i, v)}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={12}>
                <Select name="taskIcon" label="Select icon" initialValue={tasks[i].taskIcon} onChange={(v) => updateTaskIcon(i, v)}>
                  {taskIcons.map((icon, i) => (
                    <Option value={icon} key={i}>
                      <Icon iconName={icon} size="m" />
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </div>
        )}
      </div>
    ))}
    <Row>
      <Col>
        <Form.Item>
          <Button onClick={() => addTask(visualViewport)}>Add a task</Button>
        </Form.Item>
      </Col>
    </Row>
  </>
);
